import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';

const apiAuthHost = 'https://kv.api.avidratings.com/';
const apiHost = apiAuthHost + '/v1.0/';

@Injectable()
export class MicroApiService {

  sharedDataKey: string;
  constructor(private http: HttpClient) { }

  storePublicDataAsString(data: string) {
    return this.http.post(apiHost + 'keys', {
      data,
      'ttl': {
        'delta': {
          'weeks': 8,
          'hours': 0,
          'seconds': 0
        }
      }
    }, {
      headers: this.apiHeaders()
    });
  }

  fetchStoredPublicData(key: string) {
    this.sharedDataKey = key;
    return this.http.get(apiHost + 'keys/' + key, {
      headers: this.apiHeaders()
    });
  }

  apiHeaders() {
    return new HttpHeaders({'APIKey' : atob('cGhhaWo1YWVjaDNB')});
  }
}



// WEBPACK FOOTER //
// ./src/app/services/micro-api.service.ts